import {
  ChipBadge,
  IStyles,
  IconWrapper,
  Loader,
  MobilePopup,
  NoContentCard,
  QuantityButton,
  QuestionContainerWithSolution,
  deserify,
  pxToRem,
  pxTovW,
  theme,
  useCommonServiceClientContext,
  isAndroidDownloadAvailable,
  blobToDataUri,
  downloadPdfToAndroid,
  formatErrorMessages,
  uploadFile,
  getMediaBasePath,
  getFileSizeInMB,
  getFileExtensionType,
  getFileType,
  QuestionSourceTags,
  cloneObject,
  InputField,
  ActionPopUpSingleButton,
} from '@geneo2-web/shared-ui';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import {
  Autocomplete,
  Box,
  Button,
  IconButton,
  InputAdornment,
  MenuItem,
  Pagination,
  Select,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';

import { useEffect, useMemo, useRef, useState } from 'react';
import {
  CloudUpload,
  MarkingSchemeEnum,
  ModeOfConductionEnum,
  QuestionModuleMap,
  TaskInfo,
} from '@protos/learning_management/lms.db_pb';
import { useGlobalContext } from '../../../../../app/Context/GlobalContextProvider';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  bloomLevelValuesArray,
  difficultyValuesArray,
  questionValuesArray,
  toBloomLevelEnum,
  toDifficultyEnum,
  toQuestionEnum,
  toStringQuestion,
} from '../../../../../utils/functions';
import { useTextBookQuestionEnabled } from '../../../../../utils/customHooks';
import {
  useAppDispatch,
  useAppSelector,
  useDeserifiedSelector,
} from '../../../../../reduxStore/reduxHooks';
import {
  AssessmentCreationEnum,
  PaginationInfo,
} from '@protos/learning_management/lms.assessment.teacher.apis_pb';
import {
  Question,
  Question_QuestionEnum,
} from '@protos/content_management/content.db_pb';
import { EditWarningPopup } from '../../../../../components/EditWarningPopup';
import {
  setToastInfo,
  setToastInfoV2,
} from 'apps/teacher/src/pages/Home/reducer/homeDashboard.slice';
import { useDownloadContext } from '../../../../../app/Context/DownloadContextProviderV2';
import { interactionEvent } from '../../../../Auth/auth.events';
import {
  CustomUploadFileResponse,
  QuestionSourceFilter,
  setQuestionUploadFilter,
} from '../../../reducer/assessmentFlow.slice';
import { ConnectError } from '@bufbuild/connect';
import AiGeneratedButton from '../../../QuestionPaperGenerator/ReviewQuestionPaper/Buttons/AiGeneratedButton';
import { ValidationPopup } from '../../../QuestionPaperGenerator/QuestionPaperCreate/components/ValidationPopup';
import { AddQuestionsPopup } from '../../../components/UploadQuestions/AddQuestionPopup';
import { APIResponse_StatusEnum } from '@protos/common/common.db_pb';
import {
  FileUploadPurpose,
  MimeEnum,
  SignedUrlReponse,
} from '@protos/learning_management/lms.common.apis_pb';
import { ProfileRolesEnum } from '@protos/user_management/ums.db_pb';
import { IUploadStatusMessage } from '../../../components/UploadQuestions/UploadErrorCard';
import { Timestamp } from '@bufbuild/protobuf';
import { getUniqueQuestionIdsFromQpgContent } from '../../../utils/QPGv2.utils';
import { useAddOrReplaceFAQuestionMultiSubject } from '../../FAv2.utils';
import {
  getTotalAssessmentQuestionCount,
  isOmrQuestionLimitReached,
  OMR_MAX_QUESTIONS_LIMIT_MESSAGE,
} from '../../../utils/assessment.utils';
import {
  JEE_MARKING_SCHEME_ALLOWED_TYPES,
  OMR_CONDUCTION_MODE_ALLOWED_TYPES,
} from '../../../Common/ReviewAssessment/functions';
import { ModifiedSelectMenu } from '../../../Common/SearchQuestions/components/ModifiedSelectMenu';
import { QuestionBankCardSkeleton } from '../../../Common/SearchQuestions/components/QuestionBankCardSkeleton';
import {
  applyChapterCheckboxToggle,
  applyTopicCheckboxToggle,
  checkedFilterKey,
  clearChapterChecks,
  clearTopicChecks,
  moduleIdsFromCheckedFilters,
  originalModuleIdsFromSelection,
  teacherSelectionFromChapterIdsInfo,
  useQuestionBankChapterFilters,
} from '../../../utils/questionBank.utils';

const styles: IStyles = {
  root: {
    bgcolor: '#F8F8FC',
    boxSizing: 'border-box',
    // overflow: { md: 'hidden', xs: 'auto' },
    px: { xs: pxToRem(20), lg: pxTovW(240) },
  },
  mainContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: { xs: pxTovW(40) },
    overflow: 'scroll',
    height: '100%',
  },
  leftPanel: {
    flexBasis: { md: pxTovW(550), lg: pxTovW(615) },
    width: { md: pxTovW(550), lg: pxTovW(615) },
    maxWidth: { md: pxTovW(550), lg: pxTovW(615) },
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: { md: pxTovW(30) },
  },
  rightPanel: {
    flexBasis: { md: pxTovW(1000) },
    paddingBottom: { xs: pxToRem(70), md: 0 },
    mb: { xs: pxToRem(20), md: pxTovW(80) },
    overflow: { xs: 'initial', md: 'scroll' },
    flexGrow: 1,
    background: '#fff',
    borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
    boxShadow: '0px 0px 10px #E7E7E74A',
    p: { xs: pxToRem(10), md: pxTovW(20) },
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'flex-start',
    gap: { xs: pxToRem(10), md: pxTovW(30) },
    maxHeight: { md: '70vh' },
    position: 'relative',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(20), md: pxTovW(20) },
    // padding: {
    //   md: `${pxTovW(30)} ${pxTovW(40)}`,
    // },
    // bgcolor: 'common.white',
  },
  heading: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: { xs: pxToRem(10), md: pxTovW(10) },
    // borderBottom: { md: '1px solid grey' },
    py: { xs: pxToRem(20), md: pxTovW(30) },
  },
  textBox: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: { xs: pxToRem(10), md: pxTovW(0) },
    gap: { xs: pxToRem(10), md: pxTovW(10) },
    '& > * ': { display: 'inline' },
  },
  questionBank: {
    // bgcolor: 'common.white',
    padding: { md: pxTovW(30) },
    paddingBottom: { xs: pxToRem(70), md: 0 },
    borderRadius: { xs: pxToRem(30), md: pxTovW(30) },
    // border: '1px solid red',
    // overflowY: 'scroll',
  },
  selectContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(8), md: pxTovW(10) },
  },
};

export const FAQuestionBank = () => {
  const [searchText, setSearchText] = useState<string>('');
  const [appliedSearchText, setAppliedSearchText] = useState<string>('');
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const { setSelectedFunction } = useGlobalContext();
  const navigate = useNavigate();
  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const searchParams = new URLSearchParams(location.search);
  const paramModuleId = searchParams.get('moduleId');
  const paramSectionId = searchParams.get('sectionId');
  const paramSubjectId = searchParams.get('subjectId');
  const hasUrlModuleSectionSubject = Boolean(
    paramModuleId && paramSectionId && paramSubjectId
  );
  const { isOffline } = useDownloadContext();
  const dispatch = useAppDispatch();
  const fromPath = location.state?.from;
  const { user_info } = deserify(useAppSelector((state) => state.auth));
  const isTextBookQuestionEnabled = useTextBookQuestionEnabled();
  const {
    selected_question_index_for_alternate,
    selected_question_type_for_alternate,
    question_upload_filter,

    fa_content,
    fa_selected_section_number,
    fa_selected_chapters,
    fa_settings_config,
    fa_created_section_test,
  } = deserify(useAppSelector((state) => state.assessment));

  const [searchQuestionModuleMap, setSearchQuestionModuleMap] = useState<
    QuestionModuleMap[]
  >([]);
  const [loading, setLoading] = useState<'loading' | 'success' | 'error'>(
    'success'
  );
  const [isFetchingQuestions, setIsFetchingQuestions] = useState(true);
  const MAX_FILE_LIMIT_MB = 50;
  const isAlternateQuestion =
    typeof selected_question_index_for_alternate == 'number';

  // V2 only: use fa_content (aligned with ReviewPaperSection)
  const assessmentContent = fa_content?.assessmentContent ?? [];
  const sectionToShow = fa_content?.multiSubjectSections.find(
    (section) => section.sectionNo === fa_selected_section_number
  );
  const isJeeMarkingScheme =
    sectionToShow?.markingSchemeType === MarkingSchemeEnum.MARKING_SCHEME_JEE;
  const multiSubjectSubSections = sectionToShow?.multiSubjectSubSections ?? [];
  const getFormattedQuestionFromId = (id: string) => {
    const ques = assessmentContent?.find((q) => q.questionId === id);
    return ques ? new Question(ques) : undefined;
  };
  const questionsList = (includeAlternateQuestions = false): Question[] =>
    multiSubjectSubSections
      .flatMap((subSection) =>
        (subSection.subSectionMetaData ?? []).flatMap((quesList) => [
          getFormattedQuestionFromId(quesList.questionId ?? ''),
          ...(includeAlternateQuestions
            ? (quesList.alternateQuestions ?? []).map((altQuestion) =>
                getFormattedQuestionFromId(altQuestion.questionId ?? '')
              )
            : []),
        ])
      )
      .filter((val): val is Question => val !== undefined);
  const assessmentQuestions = questionsList(false);
  const totalAssessmentQuestionCount = useMemo(
    () => getTotalAssessmentQuestionCount(fa_content?.multiSubjectSections),
    [fa_content?.multiSubjectSections]
  );
  const questionIds = assessmentQuestions
    .map((q) => q.questionId ?? '')
    .filter(Boolean);
  const questionsSequenceInfo = new TaskInfo(fa_content?.questionsSequenceInfo);
  const questionSectionMetaInfo =
    questionsSequenceInfo?.questionSectionMetaInfo?.sort(
      (a, b) => (a?.sectionNo ?? 0) - (b?.sectionNo ?? 0)
    ) || [];
  const {
    LmsAssessmentTeacherAPIServiceV8WithStatusCodeHandler,
    TeacherUploadQuestionV1ClientWithStatusCodeHandler,
    LmsCommonAPIServiceV2ClientWithStatusCodeHandler,
    ContentCommonAPIServiceV1ClientWithStatusCodeHandler,
  } = useCommonServiceClientContext();
  const [difficultyModalState, setDifficultyModalState] = useState(false);
  const [quesTypeModalState, setQuesTypeModalState] = useState(false);
  const [bloomLevelModalState, setBloomLevelModalState] = useState(false);
  const [questionUsageModalState, setQuestionUsageModalState] = useState(false);
  const [validationStatus, setValidationStatus] = useState<
    { type: 'success' | 'error'; heading?: string; message: string } | undefined
  >(undefined);
  const [selectedDifficulty, setSelectedDifficulty] = useState<string | null>(
    null
  );
  const [selectedBloomLevel, setSelectedBloomLevel] = useState<string | null>(
    null
  );
  const [selectedQuestionType, setSelectedQuestionType] = useState<
    string | null
  >(
    (selected_question_type_for_alternate
      ? toStringQuestion(selected_question_type_for_alternate)
      : null) || null
  );
  const teacherChapters = sectionToShow?.chapterInfo?.chapterTopicsInfo;
  const teacherSelection = teacherSelectionFromChapterIdsInfo(teacherChapters);
  const {
    catalog: questionBankCatalog,
    chapterList,
    setChapterList,
    topicList,
    setTopicList,
    markFiltersEdited,
  } = useQuestionBankChapterFilters({
    personId: user_info?.teacherProfileId,
    subjectId: sectionToShow?.subjectId,
    fetchCourseIndexInfo: (request) =>
      ContentCommonAPIServiceV1ClientWithStatusCodeHandler.fetchCourseIndexInfo(
        request
      ),
    fallbackChapterInfo: teacherChapters,
    selection: teacherSelection,
    resetKey: `${fa_selected_section_number ?? ''}:${
      sectionToShow?.subjectId ?? ''
    }`,
  });
  const [questionList, setQuestionList] = useState<Question[]>([]);
  const [selectedPage, setSelectedPage] = useState<number>(1);
  const [paginationInfo, setPaginationInfo] = useState<
    PaginationInfo | undefined
  >(undefined);
  const fetchQuestionsGenerationRef = useRef(0);

  const selectedBloomLevelEnum = useMemo(() => {
    return selectedBloomLevel ? toBloomLevelEnum(selectedBloomLevel) : null;
  }, [selectedBloomLevel]);

  const selectedQuestionTypeEnum = useMemo(() => {
    return selectedQuestionType ? toQuestionEnum(selectedQuestionType) : null;
  }, [selectedQuestionType]);

  const selectedDifficultyEnum = useMemo(() => {
    return selectedDifficulty ? toDifficultyEnum(selectedDifficulty) : null;
  }, [selectedDifficulty]);

  const [selectedQuestionUsage, setSelectedQuestionUsage] = useState<
    string | null
  >('All');

  const [popupState, setPopupState] = useState<boolean>(false);
  const [omrQuestionLimitPopupOpen, setOmrQuestionLimitPopupOpen] =
    useState(false);
  const [FileUploading, setFileUploading] = useState(false);
  const [File, setFile] = useState<CustomUploadFileResponse | undefined>();
  const [uploadStatusMessage, setUploadStatusMessage] =
    useState<IUploadStatusMessage>({});
  const [addPromptPopupOpen, setAddPromptPopupOpen] = useState<boolean>(false);
  const [openFileUploadPopup, setOpenFileUploadPopup] = useState(false);
  const [templateDownloading, setTemplateDownloading] = useState(false);
  const [popupDetails, setPopupDetails] = useState<{
    title?: string;
    yesHandler?: () => void;
    yesToast?: string;
  }>({});
  const [replacedQuestionIds, setReplacedQuestionIds] = useState<string[]>([]);
  const addOrReplaceQuestion = useAddOrReplaceFAQuestionMultiSubject();

  const moduleIds = originalModuleIdsFromSelection(teacherSelection);

  // --------------------------------------------------------------

  const updateFile = async (initialFile: CustomUploadFileResponse) => {
    setFile(initialFile);
  };

  // --------------------------------------------------------------

  const questionTypeOptions = useMemo(() => {
    if (
      fa_content?.assessment?.modeOfConduction ===
      ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR
    ) {
      return OMR_CONDUCTION_MODE_ALLOWED_TYPES.map((type) =>
        toStringQuestion(type)
      );
    }

    if (
      fa_content?.assessment?.modeOfConduction ===
        ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_CLICKER ||
      fa_content?.assessment?.modeOfConduction ===
        ModeOfConductionEnum.MODE_OF_CONDUCTION_WEB_LIVE
    ) {
      return [
        toStringQuestion(Question_QuestionEnum.QUESTION_TYPE_MCQS),
        toStringQuestion(Question_QuestionEnum.QUESTION_TYPE_MCQM),
        toStringQuestion(Question_QuestionEnum.QUESTION_TYPE_TF),
      ];
    }
    if (isJeeMarkingScheme) {
      return JEE_MARKING_SCHEME_ALLOWED_TYPES.map((type) =>
        toStringQuestion(type)
      );
    }
    return questionValuesArray;
  }, [fa_content?.assessment?.modeOfConduction, isJeeMarkingScheme]);

  // --------------------------------------------------------------

  const FileUpload = async (filesToUpload: FileList) => {
    const file = filesToUpload[0];
    if (!file) return;
    if (
      ![
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ].includes(file.type)
    ) {
      dispatch(
        setToastInfoV2({
          label: 'Please upload a valid Excel file (.xls or .xlsx)',
          variant: 'error',
          open: true,
        })
      );

      return;
    }

    const tempUserUploads: CustomUploadFileResponse = {
      uploadFileData: new CloudUpload({
        gcpFileUrl: '',
        personId: user_info?.teacherProfileId,
        fileSizeInMb: getFileSizeInMB(file.size),
        isDeleted: false,
        externalWebResourceUrl: '',
        fileName: file.name,
        fileType: getFileType(file.type),
        fileExtensionType: getFileExtensionType(file.type),
        isUploaded: false,
        signedUrl: '',
      }),
      fileUploadStatus: 'pending',
      fileSize: file.size,
    };

    await updateFile(tempUserUploads);

    //! max file size to be 50 MB
    if (getFileSizeInMB(file.size) > MAX_FILE_LIMIT_MB) {
      tempUserUploads.uploadFileData.isUploaded = false;
      tempUserUploads.fileUploadStatus = 'Size Exceeded';
      dispatch(
        setToastInfoV2({
          label: 'File Size should be less than 50 MB',
          variant: 'error',
          open: true,
        })
      );
      return;
    }
    setFileUploading(true);
    try {
      const signedUrlResponse: SignedUrlReponse =
        await LmsCommonAPIServiceV2ClientWithStatusCodeHandler.getSignedUrlForFileUpload(
          {
            personId: user_info?.teacherProfileId,
            filesInfo: [
              {
                originalFilePath: file.name,
                mimeType: MimeEnum.MIME_XLSX,
                size:
                  getFileSizeInMB(file.size) < 0.01
                    ? 0.01
                    : getFileSizeInMB(file.size),
              },
            ],
            personType: ProfileRolesEnum.PROFILE_ROLE_TEACHER,
            fileUploadPurpose: FileUploadPurpose.FILE_UPLOAD_TEACHER_QUESTION,

            schoolId: user_info?.schoolDetails[0]?.schoolId || undefined,
          }
        );

      if (signedUrlResponse && signedUrlResponse.response.length > 0) {
        const signedUrl = getMediaBasePath(
          signedUrlResponse.response[0].signedUrl
        );
        const uploadSuccess = await uploadFile({ file, signedUrl });
        if (uploadSuccess.success === true) {
          tempUserUploads.uploadFileData.signedUrl = signedUrl;
          tempUserUploads.uploadFileData.isUploaded = true;
          tempUserUploads.fileUploadStatus = 'success';

          const response =
            await TeacherUploadQuestionV1ClientWithStatusCodeHandler.upsertTeacherQuestions(
              {
                gcsFilePath: signedUrl,
                schoolId: user_info?.schoolDetails[0]?.schoolId,
                moduleIds: moduleIds,
                teacherId: user_info?.teacherProfileId,
                subjectId: paramSubjectId
                  ? Number(paramSubjectId)
                  : sectionToShow?.subjectId,
                sectionId: fa_content?.assessment?.sectionId,
              }
            );

          if (response.status === APIResponse_StatusEnum.STATUS_SUCCESS) {
            tempUserUploads.uploadFileData.isUploaded = true;
            tempUserUploads.fileUploadStatus = 'success';
            setUploadStatusMessage({
              successMessage: response.message || 'File uploaded successfully',
            });
            fetchQuestions();
          } else {
            tempUserUploads.uploadFileData.isUploaded = false;
            tempUserUploads.fileUploadStatus = 'Upload Error';
            setUploadStatusMessage({ errors: response.validationErrors });
          }
        } else {
          tempUserUploads.uploadFileData.isUploaded = false;
          tempUserUploads.fileUploadStatus = 'Upload Error';
          dispatch(
            setToastInfoV2({
              label: `Error Occurred! Unable to upload the file.`,
              variant: 'error',
              open: true,
            })
          );
        }
        setFileUploading(false);
      } else {
        tempUserUploads.uploadFileData.isUploaded = false;
        tempUserUploads.fileUploadStatus = 'Upload Error';
        setUploadStatusMessage({ errors: ['Failed to get signed URL'] });
      }
    } catch (error: any) {
      setFileUploading(false);
      tempUserUploads.uploadFileData.isUploaded = false;
      tempUserUploads.fileUploadStatus = 'Upload Error';
      setUploadStatusMessage({ errors: [formatErrorMessages(error.message)] });
    }
  };

  // --------------------------------------------------------------

  const downloadTemplate = async () => {
    // setTemplateDownloaded(true);
    setTemplateDownloading(true);
    try {
      dispatch(
        setToastInfoV2({
          label: `Downloading template.`,
          variant: 'success',
          open: true,
        })
      );

      const response =
        await TeacherUploadQuestionV1ClientWithStatusCodeHandler.downloadTeacherQuestionsTemplate(
          {
            subjectId: paramSubjectId
              ? Number(paramSubjectId)
              : sectionToShow?.subjectId,
            teacherId: user_info?.teacherProfileId,
            sectionId: fa_content?.assessment?.sectionId,
            schoolId: user_info?.schoolDetails[0]?.schoolId,
          }
        );

      if (response.signedUrl) {
        if (isAndroidDownloadAvailable()) {
          // signedUrl is only readable by native's downloadBlob as a
          // self-contained data URI (it never fetches URLs itself), so fetch
          // the template here and convert it before handing it over.
          const fileResponse = await fetch(response.signedUrl);
          if (!fileResponse.ok) throw new Error('Failed to fetch template');
          const blob = await fileResponse.blob();
          const dataUri = await blobToDataUri(blob);
          downloadPdfToAndroid(dataUri, 'Question_Upload_Template.xlsx');
        } else {
          const link = document.createElement('a');
          link.href = response.signedUrl;
          link.setAttribute('download', 'Question_Upload_Template.xlsx'); //or any other extension
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }

        setTemplateDownloading(true);
      } else {
        dispatch(
          setToastInfoV2({
            label: `Error Occurred! Unable to download template.`,
            variant: 'error',
            open: true,
          })
        );
      }

      setTemplateDownloading(false);
    } catch (error) {
      dispatch(
        setToastInfoV2({
          label: `Error Occurred! Unable to download template.`,
          variant: 'error',
          open: true,
        })
      );
      setTemplateDownloading(false);
    }
  };
  // --------------------------------------------------------------

  const handleDelete = async (questionId: string) => {
    try {
      setLoading('loading');
      await TeacherUploadQuestionV1ClientWithStatusCodeHandler.deleteTeacherQuestions(
        {
          teacherId: user_info?.teacherProfileId,
          schoolId: user_info?.schoolDetails[0]?.schoolId,
          questionIds: [questionId],
        }
      );
      dispatch(
        setToastInfoV2({
          label: 'Question deleted successfully',
          variant: 'info',
          open: true,
        })
      );
      setLoading('success');
      fetchQuestions();
    } catch (error) {
      console.error('Error deleting question:', error);
      dispatch(
        setToastInfoV2({
          label: 'Error deleting question',
          variant: 'error',
          open: true,
        })
      );
    } finally {
      setLoading('success');
    }
  };

  // --------------------------------------------------------------

  const getFilterByPreviouslyUsed = (
    questionUsage: string | null
  ): boolean | undefined => {
    if (!questionUsage || questionUsage === 'All') return undefined;
    if (questionUsage === 'Previously Used') return true;
    if (questionUsage === 'Not Used') return false;
    return undefined;
  };

  // --------------------------------------------------------------

  // Build moduleIds for getModuleQuestionsWithFilters from chapter/topic filters.
  const getModuleIdsForQuestionsFilter = (): number[] => {
    if (paramModuleId) {
      // Deep-link / single-module context — use the module from the URL.
      return [Number(paramModuleId)];
    }

    return moduleIdsFromCheckedFilters(
      chapterList,
      topicList,
      originalModuleIdsFromSelection(teacherSelection)
    );
  };

  // --------------------------------------------------------------

  const fetchQuestions = async ({
    prompt,
    qIdsToBeIgnoredOverride,
    userFilter,
    searchTextOverride,
  }: {
    prompt?: string;
    qIdsToBeIgnoredOverride?: string[];
    userFilter?: QuestionSourceFilter;
    searchTextOverride?: string;
  } = {}) => {
    const generation = ++fetchQuestionsGenerationRef.current;
    setIsFetchingQuestions(true);
    try {
      const moduleIds = getModuleIdsForQuestionsFilter();
      const ignoreIds = hasUrlModuleSectionSubject
        ? new Set<string>()
        : new Set<string>([
            ...(qIdsToBeIgnoredOverride ?? questionIds),
            ...getUniqueQuestionIdsFromQpgContent({
              qpgContent: fa_content,
            }),
          ]);

      const effectiveSearchText = searchTextOverride ?? appliedSearchText;
      const effectiveFilter = userFilter ?? question_upload_filter?.value;
      const response =
        await LmsAssessmentTeacherAPIServiceV8WithStatusCodeHandler.getModuleQuestionsWithFilters(
          {
            teacherId: user_info?.teacherProfileId,
            // subjectId: qpgAssessmentTask?.subjectId,
            createdByUserId:
              effectiveFilter === 'teacher'
                ? user_info?.teacherProfileId
                : undefined,
            schoolId:
              effectiveFilter === 'teacher'
                ? user_info?.schoolDetails[0]?.schoolId
                : undefined,
            textbookQuestions:
              effectiveFilter === 'text-book-questions' ? true : undefined,
            subjectId: paramSubjectId
              ? Number(paramSubjectId)
              : sectionToShow?.subjectId,
            moduleIds: moduleIds,
            qIdsToBeIgnored: Array.from(ignoreIds),
            // noOfQuestions: sectionToShow?.numberOfQuestion,
            requiredQuestionTypes: selectedQuestionTypeEnum
              ? [selectedQuestionTypeEnum]
              : fa_settings_config?.marking_scheme ===
                MarkingSchemeEnum.MARKING_SCHEME_JEE
              ? fa_settings_config.question_types
              : [],
            requiredDifficultyTypes: selectedDifficultyEnum
              ? [selectedDifficultyEnum]
              : [],
            bloomLevels: selectedBloomLevelEnum ? [selectedBloomLevelEnum] : [],
            assessmentCreationType:
              AssessmentCreationEnum.ASSESSMENT_CREATION_FORMATIVE,
            modeOfConduction: fa_content?.assessment?.modeOfConduction,
            sectionId: paramSectionId
              ? BigInt(paramSectionId)
              : fa_content?.assessment?.sectionId,
            pageNumber: selectedPage,
            searchText: effectiveSearchText || undefined,
            filterByPreviouslyUsed: getFilterByPreviouslyUsed(
              selectedQuestionUsage
            ),
          }
        );

      if (generation !== fetchQuestionsGenerationRef.current) return;

      const quesList = response.data?.questions || [];

      const newSearchQuestionModuleMap = response.data?.questionModuleMap || [];
      setSearchQuestionModuleMap(newSearchQuestionModuleMap);
      setQuestionList(quesList);
      setPaginationInfo(response.data?.pagination);

      setLoading('success');
    } catch (error) {
      if (generation !== fetchQuestionsGenerationRef.current) return;
      setLoading('error');
    } finally {
      if (generation === fetchQuestionsGenerationRef.current) {
        setIsFetchingQuestions(false);
      }
    }
  };

  // --------------------------------------------------------------

  const filteredQuestionList = useMemo(() => {
    const markingScheme =
      fa_content?.assessment?.markingSchemeType ||
      fa_settings_config?.marking_scheme;
    if (markingScheme === MarkingSchemeEnum.MARKING_SCHEME_CUSTOM) {
      return questionList.map((q) => {
        const cloned = cloneObject(q) as Question;
        const cqc = cloned.question?.model?.value?.commonQuestionContent;
        if (cqc) {
          cqc.marks = [
            fa_content?.questionsSequenceInfo?.marksPerQuestion || 0,
          ];
        }
        return cloned;
      });
    } else if (markingScheme === MarkingSchemeEnum.MARKING_SCHEME_JEE) {
      return questionList.map((q) => {
        const cloned = cloneObject(q) as Question;
        const cqc = cloned.question?.model?.value?.commonQuestionContent;
        if (cqc) {
          cqc.marks = [4];
        }
        return cloned;
      });
    }
    return questionList;
  }, [questionList]);

  // --------------------------------------------------------------

  // Helper function to build common API request parameters
  const buildModuleQuestionsParams = (
    moduleIds: number[],
    currentQuestion: Question,
    prompts?: string[]
  ) => ({
    teacherId: user_info?.teacherProfileId,
    subjectId: fa_content?.assessment?.subjectId,
    sectionId: fa_content?.assessment?.sectionId,
    moduleIds,
    assessmentCreationType:
      AssessmentCreationEnum.ASSESSMENT_CREATION_QUESTION_PAPER,
    noOfQuestions: 1,
    requiredQuestionTypes: selectedQuestionTypeEnum
      ? [selectedQuestionTypeEnum]
      : [],
    requiredDifficultyTypes: selectedDifficultyEnum
      ? [selectedDifficultyEnum]
      : [],
    bloomLevels: selectedBloomLevelEnum ? [selectedBloomLevelEnum] : [],
    qIdsToBeIgnored: [
      ...questionList.map((ques) => ques.questionId || ''),
      ...replacedQuestionIds,
    ],
    currentQuestionId: currentQuestion.questionId,
  });

  // --------------------------------------------------------------

  const handleReplaceAiQuestion = async (
    currentQuestion: Question,
    prompts?: string[]
  ) => {
    if (!currentQuestion) return;

    try {
      setLoading('loading');
      setIsFetchingQuestions(true);

      // Get all module IDs
      const allModuleIds =
        fa_content?.assessment?.taskMetaInfo?.chapterInfo?.chapterTopicsInfo
          .flatMap((chapter) => [
            chapter.chapterId,
            ...chapter.topicInfo.map((topic) => topic.topicId),
          ])
          ?.sort((a, b) => a - b) || [];

      // Fetch replacement question
      const moduleQuestions =
        await LmsAssessmentTeacherAPIServiceV8WithStatusCodeHandler.getModuleQuestionsWithFilters(
          buildModuleQuestionsParams(allModuleIds, currentQuestion, prompts)
        );

      if (moduleQuestions?.data?.questions?.length) {
        const newQuestion = moduleQuestions.data.questions[0];

        // Track replaced questions
        if (
          currentQuestion.questionId &&
          !replacedQuestionIds.includes(currentQuestion.questionId)
        ) {
          setReplacedQuestionIds([
            ...replacedQuestionIds,
            currentQuestion.questionId,
          ]);
        }

        // Update question list by replacing the current question with the new one
        setQuestionList((prevList) =>
          prevList.map((q) =>
            q.questionId === currentQuestion.questionId ? newQuestion : q
          )
        );

        // Update search question module map
        const newQuestionModuleMapData =
          moduleQuestions.data?.questionModuleMap?.find(
            (val) => val.questionId === newQuestion.questionId
          );

        if (newQuestionModuleMapData) {
          setSearchQuestionModuleMap((prevMap) => [
            ...prevMap.filter(
              (val) => val.questionId !== currentQuestion.questionId
            ),
            newQuestionModuleMapData,
          ]);
        }

        dispatch(
          setToastInfo({
            label: 'Question replaced successfully',
            variant: 'info',
            open: true,
          })
        );
      } else {
        dispatch(
          setToastInfo({
            label: 'No questions found to replace',
            variant: 'error',
            open: true,
          })
        );
      }
    } catch (err) {
      let message = 'Failed to replace question';
      if (err instanceof ConnectError) {
        message = err.rawMessage?.replace(/.*\]\s*/, '').trim();
      }
      console.error('Error replacing AI question:', err);
      dispatch(
        setToastInfo({
          label: message,
          variant: 'error',
          open: true,
        })
      );
    } finally {
      setIsFetchingQuestions(false);
      setLoading('success');
    }
  };

  // --------------------------------------------------------------

  const backButtonClick = async () => {
    dispatch(setQuestionUploadFilter({ value: 'all' }));
    if (fromPath) {
      navigate(fromPath, {
        state: {
          isFromQuestionBank: true,
          redirectionPath: location.state?.redirectionPath,
        },
      });
    } else {
      navigate(-1);
    }
  };

  // --------------------------------------------------------------

  const renderSelectMenu = (
    optionList: string[],
    placeholder: string,
    value: string | null,
    onChange: (e: any, value: string | null) => void,
    onMobileClick: () => void,
    modalState: boolean,
    setModalState: (val: boolean) => void,
    disabled?: boolean
  ) => {
    if (isMobile) {
      return (
        <>
          <MobilePopup
            options={optionList}
            title={placeholder}
            modalState={modalState}
            setModalState={setModalState}
            onChange={onChange}
            clearall
          />
          <Box
            sx={{
              display: 'flex',
              height: {
                md: pxTovW(55),
                xs: pxToRem(38),
              },
              border: '1px solid #38FF92',
              borderRadius: '7px',
              boxSizing: 'border-box',
              alignItems: 'center',
              justifyContent: 'space-between',
              px: { xs: pxToRem(10), md: pxTovW(20) },
              width: '100%',
              opacity: disabled ? 0.5 : 1,
            }}
            onClick={disabled ? undefined : onMobileClick}
          >
            <Typography
              // {...params}
              variant="h4"
              sx={{
                px: pxToRem(5),
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                wordBreak: 'break-word',
              }}
            >
              {value || placeholder}
            </Typography>
            <KeyboardArrowDownRoundedIcon
              sx={{
                color: 'text.disabled',
              }}
            />
          </Box>
        </>
      );
    }
    return (
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        popupIcon={
          <KeyboardArrowDownRoundedIcon
            sx={{
              color: 'text.disabled',
              fontSize: { xs: 'small', md: 'large' },
            }}
          />
        }
        options={optionList}
        value={value}
        onChange={onChange}
        disabled={disabled}
        // disableClearable
        sx={{
          border: '1px solid #38FF92',
          borderRadius: '7px',
          width: '100%',
          '& .MuiInputBase-root': {
            backgroundColor: 'initial',
            '&:hover': {
              backgroundColor: 'initial',
            },
            '&:focus': {
              backgroundColor: 'initial',
            },
            '&:hover::before': {
              borderBottom: 'none',
            },
            '&:focus::before': {
              borderBottom: 'none',
            },
            '&::before': {
              borderBottom: 'none',
            },
            '&::after': {
              borderBottom: 'none',
            },
          },
        }}
        renderInput={(params) => (
          <TextField variant="filled" {...params} label={placeholder} />
        )}
      />
    );
  };

  // --------------------------------------------------------------

  const addQuestion = async (props: {
    question: Question;
    questionIndex?: number;
    altIndex?: number;
  }) => {
    const { question, questionIndex, altIndex } = props;

    const questionsSequenceInfo = new TaskInfo(
      fa_content?.questionsSequenceInfo
    );
    const questionToAdd = cloneObject(question);
    const marksOverride =
      sectionToShow?.markingSchemeType === MarkingSchemeEnum.MARKING_SCHEME_JEE
        ? 4
        : sectionToShow?.markingSchemeType ===
          MarkingSchemeEnum.MARKING_SCHEME_CUSTOM
        ? questionsSequenceInfo.marksPerQuestion || 0
        : undefined;
    if (
      marksOverride !== undefined &&
      questionToAdd?.question?.model?.value?.commonQuestionContent?.marks
    ) {
      questionToAdd.question.model.value.commonQuestionContent.marks[0] =
        marksOverride;
    }

    const filteredModuleMap = searchQuestionModuleMap.filter(
      (val) => val.questionId == questionToAdd.questionId
    );
    await addOrReplaceQuestion({
      question: questionToAdd,
      subSectionIndex: 0,
      questionIndex: questionIndex,
      altIdx: altIndex,
      moduleMapArray: filteredModuleMap,
    });
    // Refetch so same question cannot be added twice (updated qIdsToBeIgnored)
    await fetchQuestions({
      qIdsToBeIgnoredOverride: [
        ...questionIds,
        questionToAdd.questionId ?? '',
      ].filter(Boolean),
    });
    // if (altIndex) {
    //   navigate(QPG_ASSESSMENT_REVIEW_PAPER);
    // }
  };

  // --------------------------------------------------------------

  const handleAddQuestion = (question: Question) => {
    if (
      !isAlternateQuestion &&
      isOmrQuestionLimitReached(
        fa_content?.assessment?.modeOfConduction,
        totalAssessmentQuestionCount
      )
    ) {
      setOmrQuestionLimitPopupOpen(true);
      return;
    }

    // --------------------------------------------------------------

    // if not add alternate question, then check if question type exists in any section

    const subSectionName =
      sectionToShow?.multiSubjectSubSections?.[0]?.subSectionName;

    if (!isAlternateQuestion) {
      const sectionMeta = questionsSequenceInfo?.questionSectionMetaInfo || [];
      setPopupDetails({
        title: `Question will be added`,
        yesToast: `Question added to the section`,
        yesHandler: async () => {
          await addQuestion({ question: question });
        },
      });
      setPopupState(true);
      return;
    }
    setPopupDetails({
      title: `Choosing this will add an alternate question`,
      yesToast: `Question added to the section`,
      yesHandler: async () => {
        await addQuestion({
          question,
          questionIndex: selected_question_index_for_alternate,
        });
      },
    });
    setPopupState(true);
  };

  // --------------------------------------------------------------

  const handleSearchClick = () => {
    const trimmedSearchText = searchText.trim();
    const shouldRefetchDirectly =
      selectedPage === 1 && appliedSearchText === trimmedSearchText;

    setSelectedPage(1);
    setAppliedSearchText(trimmedSearchText);

    if (shouldRefetchDirectly) {
      fetchQuestions({ searchTextOverride: trimmedSearchText });
    }
  };

  // --------------------------------------------------------------

  const handleClearSearch = () => {
    const shouldRefetchDirectly =
      selectedPage === 1 && appliedSearchText === '';

    setSearchText('');
    setSelectedPage(1);
    setAppliedSearchText('');

    if (shouldRefetchDirectly) {
      fetchQuestions({ searchTextOverride: '' });
    }
  };

  // --------------------------------------------------------------

  const handleSearchTextChange = (newValue: string) => {
    setSearchText(newValue);

    // If user clears text via backspace/delete, reset applied search and refetch.
    if (newValue.trim() === '' && appliedSearchText !== '') {
      const shouldRefetchDirectly = selectedPage === 1;
      setSelectedPage(1);
      setAppliedSearchText('');

      if (shouldRefetchDirectly) {
        fetchQuestions({ searchTextOverride: '' });
      }
    }
  };

  // --------------------------------------------------------------

  useEffect(() => {
    setSelectedFunction(() => backButtonClick);
    return () => {
      setSelectedFunction(null);
    };
  }, []);

  // --------------------------------------------------------------

  useEffect(() => {
    fetchQuestions();
  }, [
    checkedFilterKey(chapterList, topicList),
    fa_content?.assessment?.subjectId,
    user_info?.teacherProfileId,
    selectedBloomLevel,
    selectedDifficulty,
    selectedQuestionType,
    selectedPage,
    appliedSearchText,
    selectedQuestionUsage,
  ]);

  // --------------------------------------------------------------

  if (loading === 'loading') return <Loader />;

  return (
    <Box sx={styles.root}>
      <Box sx={styles.heading}>
        {/* <Typography variant="h1">My Homework</Typography> */}
        <Box sx={styles.textBox}>
          <Typography variant="h2">Question Bank </Typography>
          <Typography variant="h3">
            <ChipBadge
              label={paginationInfo?.totalItems}
              color="primary"
              size="small"
            />
          </Typography>
        </Box>
        <Select
          value={question_upload_filter?.value}
          onChange={(e) => {
            dispatch(
              setQuestionUploadFilter({
                value: e.target.value as QuestionSourceFilter,
              })
            );
            fetchQuestions({
              userFilter: e.target.value as QuestionSourceFilter,
            });
          }}
          displayEmpty
          renderValue={() => {
            if (!question_upload_filter?.value) {
              return <Typography color="text.disabled">Select</Typography>;
            }
            if (question_upload_filter?.value === 'all') {
              return <Typography variant="cardText"> All Questions</Typography>;
            }
            if (question_upload_filter?.value === 'text-book-questions') {
              return (
                <Typography variant="cardText"> Textbook Questions</Typography>
              );
            }
            return (
              <Typography variant="cardText">
                {' '}
                Teacher Uploaded Questions
              </Typography>
            );
          }}
          sx={{
            background: '#F5FAFF',
            width: { xs: '100%', md: pxTovW(332) },
            borderRadius: { xs: pxToRem(10), md: pxTovW(5) },
            height: { xs: 'max-content', md: '70%', lg: pxTovW(65) },
            '.MuiOutlinedInput-notchedOutline': { border: '2px solid #87C5FF' },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              border: '2px solid #87C5FF',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              border: '2px solid #87C5FF',
            },
            boxShadow: 'none',
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: { xs: pxToRem(100), md: pxTovW(300) },
                minHeight: { xs: 'max-content', md: 'max-content' },
                backgroundColor: '#F8FCFF',
                '&::-webkit-scrollbar': { display: 'none' },
                padding: 0,
                borderRadius: { xs: pxToRem(15), md: pxTovW(15) },
                '& .MuiList-root': {
                  backgroundColor: '#F8FCFF',
                  maxHeight: { xs: pxToRem(150), md: pxTovW(300) },
                  padding: 0,
                },
                minWidth: { xs: '95%', md: pxTovW(230) },
                maxWidth: { xs: '95%', md: pxTovW(200), lg: pxTovW(150) },
              },
            },
          }}
        >
          <MenuItem value="all">All Questions</MenuItem>
          <MenuItem value="teacher">Teacher Uploaded Questions</MenuItem>
          {isTextBookQuestionEnabled && (
            <MenuItem value="text-book-questions">Textbook Questions</MenuItem>
          )}
        </Select>
      </Box>
      <Box sx={styles.mainContainer}>
        <Box sx={styles.leftPanel}>
          <Box sx={styles.header}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                minWidth: 0,
                boxSizing: 'border-box',
                padding: { xs: pxToRem(10), md: pxTovW(20) },
                backgroundColor: 'common.white',
                borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
                boxShadow: `0px 0px ${pxToRem(5)} #E7E7E7D9`,
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: { xs: pxToRem(10), md: pxTovW(20) },
                  paddingBottom: { xs: pxToRem(10), md: pxTovW(20) },
                  marginBottom: { xs: pxToRem(10), md: pxTovW(20) },
                }}
              >
                <InputField
                  variant="outlined"
                  fullWidth
                  onChange={(e) => handleSearchTextChange(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleSearchClick();
                    }
                  }}
                  value={searchText}
                  placeholder="Search concepts or subtopics"
                  muiOutlinedInputRoot={{
                    paddingX: {
                      xs: pxToRem(15),
                      md: pxTovW(10),
                      lg: pxTovW(20),
                    },
                    paddingY: {
                      xs: pxToRem(10),
                      md: pxTovW(25),
                      lg: pxTovW(10),
                    },
                  }}
                  sx={{
                    borderRadius: { xs: pxToRem(20), md: pxTovW(20) },
                    border: '1px solid #CCE6FE',
                    '& > div': {
                      background:
                        searchText === '' || searchText === null
                          ? 'transparent'
                          : 'linear-gradient(to right, transparent 88%,#007cdc 88% 100%)',
                      padding: '0px',
                    },
                  }}
                  InputProps={{
                    startAdornment: (searchText === '' ||
                      searchText === null) && (
                      <InputAdornment position="start">
                        <SearchIcon
                          sx={{
                            fontSize: {
                              xs: pxToRem(18),
                              md: pxToRem(20),
                              lg: pxToRem(25),
                            },
                          }}
                          color="primary"
                        />
                      </InputAdornment>
                    ),
                    endAdornment: searchText ? (
                      <InputAdornment position="end">
                        <Box
                          sx={{
                            display: 'flex',
                            gap: { xs: pxToRem(10), md: pxTovW(20) },
                          }}
                        >
                          <IconButton onClick={handleClearSearch} size="small">
                            <CloseIcon
                              color="primary"
                              sx={{
                                fontSize: {
                                  xs: pxToRem(18),
                                  md: pxToRem(20),
                                  lg: pxToRem(25),
                                },
                              }}
                            />
                          </IconButton>
                          <Box sx={{ backgroundColor: 'primary.main' }}>
                            <IconButton
                              onClick={handleSearchClick}
                              size="small"
                            >
                              <SearchIcon
                                sx={{
                                  color: 'white',
                                  fontSize: {
                                    xs: pxToRem(18),
                                    md: pxToRem(20),
                                    lg: pxToRem(25),
                                  },
                                }}
                              />
                            </IconButton>
                          </Box>
                        </Box>
                      </InputAdornment>
                    ) : null,
                  }}
                />
                <Box
                  sx={{
                    display: 'flex',
                    gap: { xs: pxToRem(10), md: pxTovW(20) },
                  }}
                >
                  {renderSelectMenu(
                    difficultyValuesArray,
                    'Difficulty Level',
                    selectedDifficulty ?? null,
                    async (e, value) => {
                      setSelectedDifficulty(value);
                      setSelectedPage(1);
                      value &&
                        (await interactionEvent({
                          context: 'Difficulty_level',
                          name: value.toUpperCase().replace(/\s+/g, '_'),
                          pathSegments: pathSegments,
                          isOffline: isOffline,
                        }));
                    },
                    () => setDifficultyModalState(true),
                    difficultyModalState,
                    setDifficultyModalState
                  )}

                  {renderSelectMenu(
                    questionTypeOptions,
                    'Question Type',
                    selectedQuestionType ?? null,
                    async (e, value) => {
                      setSelectedQuestionType(value);
                      setSelectedPage(1);
                      value &&
                        (await interactionEvent({
                          context: 'Question_type',
                          name: value
                            .toUpperCase()
                            .replace(/\s+/g, '_')
                            .replace(/\//g, '_/_'),
                          pathSegments: pathSegments,
                          isOffline: isOffline,
                        }));
                    },
                    () => setQuesTypeModalState(true),
                    quesTypeModalState,
                    setQuesTypeModalState,
                    !!selected_question_type_for_alternate
                  )}
                </Box>

                {sectionToShow?.markingSchemeType !==
                  MarkingSchemeEnum.MARKING_SCHEME_JEE && (
                  <Box
                    sx={{
                      display: 'flex',
                      gap: { xs: pxToRem(10), md: pxTovW(20) },
                    }}
                  >
                    {renderSelectMenu(
                      bloomLevelValuesArray,
                      'Bloom Level',
                      selectedBloomLevel ?? null,
                      async (e, value) => {
                        setSelectedBloomLevel(value);
                        setSelectedPage(1);
                        value &&
                          (await interactionEvent({
                            context: 'Bloom_level',
                            name: value.toUpperCase().replace(/\s+/g, '_'),
                            pathSegments: pathSegments,
                            isOffline: isOffline,
                          }));
                      },
                      () => setBloomLevelModalState(true),
                      bloomLevelModalState,
                      setBloomLevelModalState
                    )}
                    {/* empty box so that above box takes 50% width */}
                    <Box sx={{ width: '100%' }} />
                  </Box>
                )}

                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: { xs: pxToRem(10), md: pxTovW(20) },
                    borderTop: '1px dashed #E3E3E3',
                    pt: { xs: pxToRem(10), md: pxTovW(20) },
                  }}
                >
                  <ModifiedSelectMenu
                    header={'Search by Chapter'}
                    list={chapterList}
                    clearFunction={() => {
                      markFiltersEdited();
                      const next = clearChapterChecks(chapterList, questionBankCatalog);
                      setChapterList(next.chapterList);
                      setTopicList(next.topicList);
                      setSelectedPage(1);
                    }}
                    onChangeCheckbox={(listData) => {
                      markFiltersEdited();
                      const next = applyChapterCheckboxToggle(
                        questionBankCatalog,
                        chapterList,
                        topicList,
                        listData.id
                      );
                      setChapterList(next.chapterList);
                      setTopicList(next.topicList);
                      setSelectedPage(1);
                      if (!listData.checked) {
                        const chapterName =
                          questionBankCatalog.find(
                            (chapter) => chapter.chapterId === listData.id
                          )?.name ?? listData.name;
                        interactionEvent({
                          context: 'Search_by_chapter',
                          name: chapterName
                            .toUpperCase()
                            .replace(/\s+/g, '_')
                            .replace(/[:.]/g, ''),
                          pathSegments: pathSegments,
                          isOffline: isOffline,
                        });
                      }
                    }}
                  />
                  <ModifiedSelectMenu
                    header={'Search by Topic'}
                    list={topicList}
                    clearFunction={() => {
                      markFiltersEdited();
                      setTopicList(clearTopicChecks(topicList));
                      setSelectedPage(1);
                    }}
                    onChangeCheckbox={(listData) => {
                      markFiltersEdited();
                      const next = applyTopicCheckboxToggle(
                        questionBankCatalog,
                        chapterList,
                        topicList,
                        listData.id
                      );
                      setChapterList(next.chapterList);
                      setTopicList(next.topicList);
                      setSelectedPage(1);
                      if (!listData.checked) {
                        interactionEvent({
                          context: 'Search_by_topic',
                          name: listData.name
                            .toUpperCase()
                            .replace(/\s+/g, '_')
                            .replace(/[:.]/g, ''),
                          pathSegments: pathSegments,
                          isOffline: isOffline,
                        });
                      }
                    }}
                  />
                  <Box sx={styles.selectContainer}>
                    <Typography variant="h4" fontWeight={'bold'}>
                      Question usage
                    </Typography>
                    {renderSelectMenu(
                      ['Previously Used', 'Not Used', 'All'],
                      'Question usage',
                      selectedQuestionUsage ?? null,
                      async (e, value) => {
                        setSelectedQuestionUsage(value ?? 'All');
                        setSelectedPage(1);
                        value &&
                          (await interactionEvent({
                            context: 'Question_usage',
                            name: value.toUpperCase().replace(/\s+/g, '_'),
                            pathSegments: pathSegments,
                            isOffline: isOffline,
                          }));
                      },
                      () => setQuestionUsageModalState(true),
                      questionUsageModalState,
                      setQuestionUsageModalState
                    )}
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      gap: { xs: pxToRem(10), md: pxTovW(20) },
                    }}
                  >
                    <Box
                      sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <Box
                        sx={{
                          p: {
                            xs: `${pxToRem(8)} ${pxToRem(10)}`,
                            md: `${pxTovW(10)} ${pxTovW(12)}`,
                          },
                          borderRadius: { xs: pxToRem(5), md: pxTovW(10) },
                          border: '1px solid #0AA34F',
                          cursor: 'pointer',
                          background: '#CFFFE5',
                          display: 'flex',
                          alignItems: 'center',
                          gap: { xs: pxToRem(5), md: pxTovW(10) },
                        }}
                        onClick={() => {
                          setOpenFileUploadPopup(true);
                        }}
                      >
                        <IconWrapper
                          name="blue-plus"
                          customSx={{ height: '23px', width: '23px' }}
                          type="png"
                          parentFolder="icons"
                        />
                        <Typography
                          variant="cardText"
                          color={'#007CDC'}
                          fontWeight={'600'}
                        >
                          Add Your Own Questions
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box sx={styles.rightPanel}>
          {isFetchingQuestions ? (
            <QuestionBankCardSkeleton />
          ) : filteredQuestionList.length > 0 ? (
            filteredQuestionList.map((q, index) => (
              <Box key={'ques_' + index}>
                <QuestionContainerWithSolution
                  questionNumber={
                    (selectedPage - 1) * (paginationInfo?.itemsPerPage ?? 20) +
                    index +
                    1
                  }
                  question={q}
                  isPreviouslyUsed={
                    searchQuestionModuleMap.find(
                      (m) => m.questionId === q.questionId
                    )?.isPreviouslyUsed
                  }
                  hideBloomLevel={
                    sectionToShow?.markingSchemeType ===
                    MarkingSchemeEnum.MARKING_SCHEME_JEE
                  }
                  showQuestionStats
                  showAnswer
                  imageResizeEnabled={true}
                  key={'ques_' + index}
                  headerLeftElement={
                    <>
                      {q.isAiGenerated ? (
                        <AiGeneratedButton
                          handlePrompt={(prompt) => {
                            handleReplaceAiQuestion(q, [prompt]);
                          }}
                        />
                      ) : null}
                      <QuestionSourceTags
                        question={q}
                        teacherProfileId={user_info?.teacherProfileId}
                        teacherName={user_info?.userName}
                      />
                    </>
                  }
                  headerRightElement={
                    hasUrlModuleSectionSubject ? undefined : (
                      <>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: { xs: pxToRem(5), md: pxTovW(10) },
                          }}
                        >
                          <Button
                            sx={{ marginLeft: 'auto' }}
                            onClick={async () => {
                              handleAddQuestion(q);
                              await interactionEvent({
                                context: 'Question_bank',
                                name: 'ADD',
                                pathSegments: pathSegments,
                                isOffline: isOffline,
                              });
                            }}
                          >
                            <QuantityButton
                              buttonText={
                                isAlternateQuestion ? 'Choose' : 'Add'
                              }
                              quantity={0}
                              maxQuantity={1}
                            />
                          </Button>
                          {q.createdBy === user_info?.teacherProfileId ? (
                            <IconWrapper
                              name={'deletehw'}
                              size="md"
                              type="png"
                              parentFolder="icons"
                              customSx={{
                                width: {
                                  xs: pxToRem(17),
                                  md: pxTovW(35),
                                  lg: pxTovW(24),
                                },
                                margin: { xs: pxToRem(10), md: 0 },
                              }}
                              onClick={() => handleDelete(q.questionId || '')}
                            />
                          ) : (
                            <></>
                          )}
                        </Box>
                      </>
                    )
                  }
                />
              </Box>
            ))
          ) : (
            <NoContentCard
              variant="info"
              icon="cards"
              text="No Questions Available"
            />
          )}

          {(paginationInfo?.totalPages ?? 1) > 1 && (
            <Pagination
              page={selectedPage}
              count={paginationInfo?.totalPages}
              color="primary"
              disabled={isFetchingQuestions}
              onChange={async (
                event: React.ChangeEvent<unknown>,
                page: number
              ) => {
                if (isFetchingQuestions) return;
                setSelectedPage(page);
              }}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'fixed',
                bottom: 0,
                left: { xs: pxToRem(10), md: 'unset' },
                border: '1px solid #007CDC',
                borderTopLeftRadius: { xs: pxToRem(10), md: pxTovW(16) },
                borderTopRightRadius: { xs: pxToRem(10), md: pxTovW(16) },
                boxShadow: '0px 0px 10px #00000029',

                width: { xs: '95%', md: pxTovW(950), lg: pxTovW(840) },
                height: { xs: pxToRem(55), md: pxTovW(85) },
                marginX: 'auto',
                mb: pxTovW(10),
                backgroundColor: '#E9F5FF',
              }}
            />
          )}
        </Box>
      </Box>

      <ActionPopUpSingleButton
        open={omrQuestionLimitPopupOpen}
        handleClose={() => setOmrQuestionLimitPopupOpen(false)}
        fontSmall
        iconName="error_yellow2"
        popupText={OMR_MAX_QUESTIONS_LIMIT_MESSAGE}
        ctaHandler={() => setOmrQuestionLimitPopupOpen(false)}
        buttontext="OK"
        background="rgba(193, 248, 218, 1)"
      />

      <EditWarningPopup
        open={popupState}
        handleClose={() => {
          setPopupState(false);
        }}
        yesClickHandler={async () => {
          if (popupDetails.yesHandler) {
            await popupDetails.yesHandler();
          }
          if (popupDetails.yesToast) {
            dispatch(
              setToastInfo({
                label: popupDetails.yesToast,
                open: true,
                variant: 'info',
              })
            );
          }
          setPopupState(false);
        }}
        noClickHandler={() => {
          setPopupState(false);
        }}
        iconname={'correct'}
        text1={popupDetails.title || ''}
        text2={'Would you like to proceed?'}
      />

      <ValidationPopup
        open={!!validationStatus}
        handleClose={() => {
          setValidationStatus(undefined);
          setAddPromptPopupOpen(true);
        }}
        okHandler={() => {
          setValidationStatus(undefined);
          setAddPromptPopupOpen(true);
        }}
        iconname={
          validationStatus?.type == 'success'
            ? 'check-green'
            : validationStatus?.type == 'error'
            ? 'wrong'
            : undefined
        }
        text1={validationStatus?.heading}
        text2={validationStatus?.message}
      />
      <AddQuestionsPopup
        open={openFileUploadPopup}
        handleClose={() => {
          setFileUploading(false);
          setFile(undefined);
          setUploadStatusMessage({});
          setOpenFileUploadPopup(false);
        }}
        retryUploadFunction={() => {
          setFileUploading(false);
          setFile(undefined);
          setUploadStatusMessage({});
        }}
        downloadClickHandler={downloadTemplate}
        templateDownloading={templateDownloading}
        instructions={[
          'Download the question template from the DownLoad Template button',
          'Fill in your questions following the format specified in the template',
          'Ensure all required fields are completed (question text, options, correct answer, difficulty level)',
          'Save the file in .xlsx or .csv format',
          'Upload the completed file using the upload section below',
          'Review the uploaded questions before adding them to your question bank',
        ]}
        userUploadedFile={File}
        FileUploading={FileUploading}
        handleChangeFunction={(event) => {
          FileUpload(event.target.files as FileList);
          event.target.value = '';
        }}
        uploadStatusMessage={uploadStatusMessage}
        setUploadStatusMessage={setUploadStatusMessage}
      />
    </Box>
  );
};
